module.exports = __webpack_public_path__ + "img/wallet-w-bg.15c5623d.svg";